import * as actions from '../actions';


const initState = {
  approvedTokens: null,
  tokenApproval: null
}

export const approvalReducer = (state = initState, action) => {
  switch (action.type) {
    case actions.SET_APPROVED_TOKENS:
      return {
        ...state,
        ...action.payload
      }
    case actions.SET_IS_TOKEN_APPROVED:
      return {
        ...state,
        ...action.payload
      }

    default:
      return state
  }
}
